//import { Menu, MenuItem } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

//import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchUser from '../../../Components/shared/SearchUser';
import { statutDocAdministratifsClient } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
// import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { calculateAppelsOffresOuverts, DateValidationEntrprise, getNomPrenomClearFromPersoData, searchLabelInEnumByValue, ValiderDocAdministratifsClient } from '../../../Utils/utils';
//import {ClearIcon} from '@mui/icons-material/Clear';
//import {DeleteOutlinedIcon} from '@mui/icons-material/DeleteOutlined';

function FicheClients() {
    const { addEuro4Decimal } = useNumberFormatting();

    const [clients, setClients] = useState();
    const [dataClients, setDataClients] = useState();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    const { postData } = usePostRequest();
    const [chargeRecrutement, setChargeRecrutement] = useState();
    const [selectedRow, setSelectedRow] = useState();
    const { setBackdropOpen } = useUtilities();
    const [permissionToAffectRole,setPermissionToAffectRole]=useState(false);
    const [selectedRowMui, setSelectedRowMui] = React.useState(null);
    const { i18n } = useTranslation();
    const columns = [
        {
            field: 'clientId',
            title: i18n.t('Réf.client'),
            render: rowData => (
                <Button
                    variant='text'
                    onClick={() => {
                        console.log(rowData);
                        let endpoint=(location?.pathname?.includes('gestionEsn') ? '/admin/gestionEsn/' : '/admin/gestionClient/');
                        navigate(endpoint + rowData._id + '/CompteClient');
                    }}
                >
                    {rowData?.clientId}
                </Button>
            )
        },
        {
            field: 'nom',
            title: i18n.t('Nom client'),
        },
        {
            field: 'statutcompte',
            title: i18n.t('Statut du compte'),
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'pays',
            title: i18n.t('Pays et ville'),
        },
        {
            field: 'Aoouverts',
            title: i18n.t('AO ouverts'),
            //date d'aujourdui > date fin d'appel d'offre
        },
        {
            field: 'Nbmissions',
            title: i18n.t('Nombre de missions'),
        },
        {
            field: 'chargerecrutement',
            title: i18n.t('Chargé de recrutement affecté'),
            render: rowData => {
                return (
                    <>
                        <SearchUser
                            width={220}
                            userType={'BackOffice'}
                            userId={rowData?.idrecrut}
                            setUser={(value) => {
                                if(value){
                                    setChargeRecrutement(value);
                                    setSelectedRow(rowData);
                                    console.log('value',value);
                                    // * this was a useless line, it copies the array into an object, and add idrecrut to the object ,,
                                    setDataClients((prevRowData) => {
                                    // let dataClientsTemp = prevRowData;
                                    // Find the index of the object with the specified id
                                        let indexToUpdate = prevRowData.findIndex(obj => obj._id == rowData?._id);
                                        // Update the property if the object is found
                                        if (indexToUpdate !== -1) {
                                            prevRowData[indexToUpdate]['idrecrut'] = value?._id;
                                            // Resulting array of objects
                                            console.log(prevRowData);
                                        } else {
                                            console.log('Object not found in the array.');
                                        }
                                        return prevRowData;
                                    });
                                }
                            }
                            }
                            disabled={permissionToAffectRole}
                            size='medium'
                        />
                        {/*<Button
                            variant='text'
                            onClick={(event) => {
                                setAnchorEl(event.currentTarget);
                                setSelectedRow(rowData);
                            }}
                            disabled={permissionToAffectRole}
                        >
                            {rowData?.chargerecrutement}
                        </Button>
                        <Menu
                            //id="long-menu"
                            //MenuListProps={{
                            //    'aria-labelledby': 'long-button',
                            //}}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                style: {
                                    width: 350,
                                },
                            }}
                        >
                            <MenuItem>
                                <SearchUser
                                    width={320}
                                    userType={'BackOffice'}
                                    user={chargeRecrutement}
                                    setUser={setChargeRecrutement}
                                    size='medium'
                                />
                            </MenuItem>
                        </Menu>*/}
                    </>
                );
            }
        },
        {
            field: 'tva',
            title: i18n.t('TVA appliqué'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tva,' %');
            }
        },
        {
            field: 'statutDocAdministratifs',
            title: i18n.t('Statut doc administratifs'),
            render: rowData => {
                return i18n.t(searchLabelInEnumByValue(statutDocAdministratifsClient,rowData?.statutDocAdministratifs));
            }
        },
        {
            field: 'Option',
            title: i18n.t('Option'),
            render: rowData =>{
                return (
                    <Button
                        bdc={rowData.clientId}
                        variant="outlined"
                    //startIcon={<ArrowBack />}
                    >
                        {i18n.t('Bloquer l\'utilisateur')}
                    </Button>
                );
            }
        },
    ];

    useEffect(() => {
        getMyInfos();
    },[]);

    useEffect(() => {
        // recently start supporting consulation token
        // but support also abortCntrller : concel our request if the conponent didUnmount
        // const controller = new AbortController();

        // ! tocall :
        getAllClients();
        // cleanup fct of use Effect, runs when the compo unMount
    }, []);

    useEffect(() => {
        if (clients) {
            let Array1 = [];
            //let statutDoc='validé';
            //let statutCompte='validé';
            clients?.reverse()?.forEach(companyData => {
                const statutDoc=ValiderDocAdministratifsClient(companyData?.docsAdministratifs);
                // console.log('nom', getNomPrenomClearFromPersoData(companyData?.backOfficeId?.persoData),
                // 'companyData?.Managers[0] ',companyData?.Managers.length>0 ? companyData?.Managers[0] : 'null');
                // console.log('managers',companyData?.Managers);
                Array1.push({
                    '_id': companyData?._id,
                    'clientId': companyData?.clientId ?? companyData?.esnId,
                    'idrecrut':companyData?.backOfficeId?._id,
                    'nom': companyData?.profileEntreprise?.nom,
                    'statutcompte': (statutDoc === 'valide' || statutDoc === 'expire')
                        ? i18n.t('Activé')
                        : i18n.t('Non activé'),
                    'dateValidationEntreprise':DateValidationEntrprise(companyData?.docsAdministratifs)?.dateValidation,
                    //'ville': '??',
                    //formatDateJJMMYYYY(element?.createdAt),
                    'pays': companyData?.profileEntreprise?.localisation,
                    'Aoouverts': calculateAppelsOffresOuverts(companyData?.AOs),
                    'Nbmissions': companyData?.missions?.length,
                    'chargerecrutement': getNomPrenomClearFromPersoData(companyData?.backOfficeId?.persoData), //Array ??
                    'tva':companyData?.donneeFacturation?.tauxTva,
                    'statutDocAdministratifs':statutDoc,
                    ...companyData
                });
            });
            console.log({Array1});
            setDataClients(Array1);
        }
    }, [clients]);

    useEffect(async () => {
        if (chargeRecrutement) {
            console.log({ selectedRow });
            let endpoint=(location?.pathname?.includes('gestionEsn') ?'/esn/affecterChargeRecrutementAClient':'/client/affecterChargeRecrutementAClient');
            await postData({
                url: endpoint,
                payload:
                {
                    chargeRecrutementId: chargeRecrutement?._id,
                    ...(location.pathname.includes('gestionEsn') ? {esnId: selectedRow?._id}:
                        {clientId: selectedRow?._id})
                }
            });
            getAllClients();
        }
    }, [chargeRecrutement]);

    const getAllClients = async () => {
        setBackdropOpen(true);
        let endpoint=(location?.pathname?.includes('gestionEsn') ?'/users/getAllEsn':'/users/getAllClients');
        try {
            console.log('HELLO FROM the USERS useEffect');
            const response = await axiosPrivate.get(endpoint, {
                // signal: controller.signal
            });
            console.log('dataclient',response.data);
            //?  if is mounted==true do next [setUsers..]
            setClients(response.data);
        } catch (error) {
            console.log(error);
            false && navigate('/login', { state: { from: location }, replace: true });
        }
        setBackdropOpen(false);
    };

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            console.log('response.data',response.data);
            if(!(response.data?.backOffice?.roles?.littleAdmin || response.data?.backOffice?.roles?.Admin)){
                setPermissionToAffectRole(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')?i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')}  &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{location?.pathname?.includes('gestionEsn') ? i18n.t('Fiches des Esn'):i18n.t('Fiches des clients')} </span> </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>{location?.pathname?.includes('gestionEsn') ? i18n.t('Fiches des Esn'):i18n.t('Fiches des clients')}</h4>
                <MaterialTableComponent
                    columns={columns}
                    data={dataClients}
                    title={i18n.t('Fiches des clients')}
                    onRowClick={(event, rowData) => {
                        setSelectedRowMui(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRowMui}
                />
            </div>
        </>

    );
}

export default FicheClients;